import React, {Component} from 'react';
import PropTypes from 'prop-types';

import formStyles from './RegistrationForm.scss';
import styles from './DoctorDocumentForm.scss';
import {
    Button, DropDownList,
    Form,
    FormCheckbox,
    FormDropDownList,
    FormFieldWrapper,
    FormPhoneNumber,
    FormRadioGroup,
    FormTextField,
    InputFile
} from 'components/controls';
import validateDoctorDocumentFields from './validateDoctorDocumentFields';
import StatesDropDownList from '../../controls/StatesDropDownList';
import defaultContactInformation from 'sources/constants/defaultContactInformation';

const NPI_NUMBER = [{label: loc('yes-label'), value: 'yes-label'}, {label: loc('no-label'), value: 'no-label'}, {
    label: loc('not-sure-label'),
    value: 'not-sure-label'
}];

const DEA_NUMBER = [{label: loc('yes-label'), value: 'yes-label'}, {label: loc('no-label'), value: 'no-label'}];

const DOCTOR_DOCUMENTS_TYPES = ['cv', 'medicalDiploma', 'residencyDiploma', 'pharmacyCertificate', 'stateMedicalLicences'];

export default class DoctorDocumentForm extends Component {
    static propTypes = {
        onScroll: PropTypes.func.isRequired,
        registrationError: PropTypes.any,
        registrationProcessing: PropTypes.bool,
        fieldValues: PropTypes.any,
        onFieldChange: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        onSaveAndExit: PropTypes.func.isRequired,
        onChangeState: PropTypes.func.isRequired,
    };

    state = {
        chosenTypeOfDocument: '',
        errorDocumentType: '',
        errorUploadedType: '',
    };

    handleChangeUsePlatformAddressInfo = ({target: {value}}) => {
        const {onChangeState} = this.props;
        onChangeState({
            usePlatformContactInformation: value,
            phoneNumber: value ? defaultContactInformation.phoneNumber : '',
            faxNumber: value ? defaultContactInformation.faxNumber : '',
            workAddress: value ? defaultContactInformation.workAddress : '',
            workCity: value ? defaultContactInformation.workCity : '',
            workState: value ? defaultContactInformation.workState : '',
            workZip: value ? defaultContactInformation.workZip : '',
        });
    }

    render() {
        const {
            registrationError,
            registrationProcessing,
            fieldValues,
            onFieldChange,
            onSubmit,
            onSaveAndExit,
            onScroll,
        } = this.props;
        const {usePlatformContactInformation} = fieldValues;
        return (
            <Form className={styles.form}
                fieldValues={fieldValues}
                clientValidate={validateDoctorDocumentFields}
                serverError={registrationError}
                processing={registrationProcessing}
                onFieldChange={onFieldChange}
                onSubmit={onSubmit}
                onScrollToTop={onScroll}
                scrollOnError
                ref='form'>
                <FormCheckbox
                    label={loc('use-organization-address')}
                    checked={usePlatformContactInformation}
                    onChange={this.handleChangeUsePlatformAddressInfo}
                    labelNote={loc('organization-address-note')}
                    plainChangeHandler
                />
                <FormFieldWrapper type='FormFieldWrapper' className={styles.twoColRow}>
                    <FormPhoneNumber fieldKey='phoneNumber'
                        type='tel'
                        label={loc('phoneNumber-label')}
                        disabled={usePlatformContactInformation}
                        placeholder={loc('phoneNumber-placeholder')} />
                    <FormPhoneNumber fieldKey='faxNumber'
                        type='tel'
                        label={loc('faxNumber-label')}
                        disabled={usePlatformContactInformation}
                        placeholder={loc('faxNumber-placeholder')} />
                </FormFieldWrapper>
                <FormPhoneNumber fieldKey='homePhoneNumber'
                    type='tel'
                    label={loc('homePhone-label')}
                    placeholder={loc('homePhone-placeholder')} />
                <FormFieldWrapper type='FormFieldWrapper' className={styles.twoColRow}>
                    <FormTextField fieldKey='homeAddress'
                        type='text'
                        label={loc('homeAddress-plain-label')}
                        placeholder={loc('homeAddress-plain-placeholder')} />
                    <FormTextField fieldKey='workAddress'
                        type='text'
                        label={loc('workAddress-label')}
                        disabled={usePlatformContactInformation}
                        placeholder={loc('workAddress-placeholder')} />
                </FormFieldWrapper>
                <FormFieldWrapper type='FormFieldWrapper' className={styles.twoColRow}>
                    <FormTextField fieldKey='homeCity'
                        type='text'
                        label={loc('homeCity-label')}
                        placeholder={loc('homeCity-placeholder')} />
                    <FormTextField fieldKey='workCity'
                        type='text'
                        label={loc('workCity-label')}
                        disabled={usePlatformContactInformation}
                        placeholder={loc('workCity-placeholder')} />
                </FormFieldWrapper>
                <FormFieldWrapper type='FormFieldWrapper' className={styles.twoColRow}>
                    <StatesDropDownList
                        fieldKey='homeState'
                        label={loc('homeState-label')}
                        placeholder={loc('homeState-placeholder')}
                        multipleSelection={false}
                        canBeNotSelected={false}
                        isFormElement
                    />
                    <StatesDropDownList
                        fieldKey='workState'
                        label={loc('workState-label')}
                        disabled={usePlatformContactInformation}
                        placeholder={loc('workState-placeholder')}
                        multipleSelection={false}
                        canBeNotSelected={false}
                        isFormElement
                    />
                </FormFieldWrapper>
                <FormFieldWrapper type='FormFieldWrapper' className={styles.twoColRow}>
                    <FormTextField fieldKey='homeZip'
                        type='text'
                        label={loc('homeZip-label')}
                        placeholder={loc('homeZip-placeholder')} />
                    <FormTextField fieldKey='workZip'
                        type='text'
                        label={loc('workZip-label')}
                        disabled={usePlatformContactInformation}
                        placeholder={loc('workZip-placeholder')} />
                </FormFieldWrapper>
                <FormFieldWrapper type='FormFieldWrapper' className={styles.twoColRow}>
                    <FormRadioGroup
                        values={NPI_NUMBER}
                        selected={fieldValues.npiNumber}
                        fieldKey={'npiNumber'}
                        className={styles.radioContainer}
                        label={loc('npi-number-label')}
                        onChange={onFieldChange}
                    />
                    <FormRadioGroup
                        values={DEA_NUMBER}
                        selected={fieldValues.deaNumber}
                        fieldKey={'deaNumber'}
                        className={styles.radioContainer}
                        label={loc('dea-number-label')}
                        onChange={onFieldChange}
                    />
                    {fieldValues.npiNumber === 'yes-label'
                        ? <FormTextField
                            fieldKey='npiNumberValue'
                            type='number'
                            value={fieldValues.npiNumberValue}
                            label={loc('npi-number-value-label')}
                            placeholder={loc('npi-number-value-placeholder')}
                        />
                        : <div />}
                    {fieldValues.deaNumber === 'yes-label'
                        ? <FormTextField
                            fieldKey='deaNumberValue'
                            value={fieldValues.deaNumberValue}
                            label={loc('dea-number-value-label')}
                            placeholder={loc('dea-number-value-placeholder')}
                        />
                        : <div />}
                </FormFieldWrapper>
                <FormFieldWrapper type='FormFieldWrapper' className={styles.documentWrapper}>
                    <FormDropDownList
                        fieldKey={'chosenTypeOfDocument'}
                        label={loc('document-type-label')}
                        placeholder={loc('document-type-placeholder')}
                        formatter={::this.formatDocumentsTypes}
                        textFormatter={::this.formatTextType}
                        items={DOCTOR_DOCUMENTS_TYPES}
                    value={this.state.chosenTypeOfDocument}
                    canBeNotSelected
                        error={this.state.errorDocumentType}
                    onChange={::this.handleChangeDocumentType}
                />
                    <div className={styles.documentNote}>{loc('document-note')}</div>
                    <div className={styles.fileButtonContainer}>
                        {this.state.errorUploadedType &&
                            <div className={styles.error}>{this.state.errorUploadedType}</div>}
                        <InputFile accept={'image/jpeg,image/png,image/gif,application/pdf'}
                            ref='file'
                            onSelect={::this.handleChooseFile}
                                   onCancelSelection={::this.handleCancelFile}/>
                        <Button type={'cancel'} onClick={::this.handleUploadButtonClick} label={loc('upload-label')}/>
                        <div className={styles.fileContainer}>
                            {this.renderDocuments()}
                        </div>
                    </div>
                </FormFieldWrapper>
                <FormFieldWrapper type='FormFieldWrapper'>
                    <FormCheckbox
                        fieldKey={'signature'}
                        label={loc('signature-label')}
                        checkboxLabel={loc('signature-text')}
                        checked={fieldValues.signature}
                        onChange={onFieldChange}
                    />
                </FormFieldWrapper>

                <div className={formStyles.actionContainer}>
                    <Button type='submit'
                        label={loc('sign-up-label')}
                        className={formStyles.submitButton} />
                    <Button type='cancel'
                        label={loc('save-continue-label')}
                        className={formStyles.submitButton}
                        onClick={onSaveAndExit} />
                </div>

                <div className={formStyles.formNote} dangerouslySetInnerHTML={{__html: loc('disclaimer')}} />

            </Form>
        );
    }

    renderDocuments() {
        const {fieldValues} = this.props;
        return DOCTOR_DOCUMENTS_TYPES.map((type, index) => {
            if (!fieldValues[type])
                return null;
            return (
                <div key={index} className={styles.document}>
                    <div className={styles.fileIcon} />
                    {loc(type)}
                    <div className={styles.deleteButton} onClick={this.deleteDocument.bind(this, type)}>x</div>
                </div>
            )
        });
    }

    deleteDocument(type) {
        const {onFieldChange} = this.props;
        onFieldChange(type, {target: {value: null}});
    }

    formatDocumentsTypes = value => {
        if (!value)
            return loc('document-type-placeholder');

        return loc(value);
    };

    formatTextType = (item, text) => {
        if (!item)
            return text;

        const {fieldValues} = this.props;
        return (
            <div className={styles.documentType}>
                {text}
                {fieldValues[item] && <div className={styles.accept} />}
            </div>
        );
    };

    handleDropdownChanged(name, value) {
        const {onFieldChange} = this.props;
        onFieldChange(name, value);
    }

    handleChangeDocumentType(e) {
        this.setState({chosenTypeOfDocument: e.target.value, errorDocumentType: ''});
    }

    handleChooseFile(file) {
        const {onFieldChange} = this.props;
        const {chosenTypeOfDocument} = this.state;
        onFieldChange(chosenTypeOfDocument, {target: {value: file}});
        this.setState({chosenTypeOfDocument: ''});
    }

    handleCancelFile() {
    }

    handleUploadButtonClick() {
        const {chosenTypeOfDocument} = this.state;
        if (!chosenTypeOfDocument)
            return this.setState({errorDocumentType: loc('no-chosen-document-type')});
        this.refs.file.select();
    }
}



// WEBPACK FOOTER //
// ./src/components/Auth/Register/DoctorDocumentForm.js